import getOverrides from 'APP_ROOT/utils/get-field-overrides';
import getDisableAllFields from './getDisableAllFields';
import { TEXT, TEXTAREA, NUMBER, MASKED } from 'APP_ROOT/constants/fieldTypes';

const getFieldIsDisabled = props => {
  const {
    overrides = {},
    behavior = 'hide',
    isEditor = false,
    disable: turnedOff = false,
    internetAccess,
    autoSaveDraft,
    field_type,
  } = props;

  if (!internetAccess || autoSaveDraft) return true;

  const disableAllFields = getDisableAllFields(props);

  if (disableAllFields) {
    return disableAllFields;
  }

  if (isEditor && turnedOff) {
    return turnedOff;
  }

  const getFieldOverrides = getOverrides(props, overrides);
  const options = getFieldOverrides('options', {});

  const { disable = false, readOnly = false } = options;
  const { readOnly: propsReadOnly = false } = props;

  if (readOnly || propsReadOnly) {
    const nativelySupported = [TEXT, TEXTAREA, NUMBER, MASKED];
    const isNativelySupported = nativelySupported.some(
      type => type === field_type
    );

    return !isNativelySupported;
  }

  return disable || behavior === 'disable';
};

export default getFieldIsDisabled;
